{
  "en": {
    "login": {
      "acceptTosPrefix": "I accept the ",
      "acceptTos": "terms and conditions",
      "acceptTosRequired": "You must accept the terms and conditions to create an account.",
      "auth/invalid-credential": "The password is invalid for the given email, or an account for this email does not exist.",
      "auth/invalid-email": "The email address is not valid.",
      "auth/too-many-requests": "Too many requests, please try again later.",
      "auth/network-request-failed": "A network error occurred. Please check your connection and try again.",
      "auth/invalid-action-code": "For security reasons, password reset links expire after a little while. If you still need to reset your password, you can request a new reset email.",
      "auth-ziggu/invalid-invitation-code": "Please check with the person who shared it with you to see if there's a new link available. If you already have an account, please login instead.",
      "auth-ziggu/user-created": "Your user account has been created! 🎉 We are now signing you in, hold on..",
      "title_login": "Welcome back!",
      "title_password_forgot": "Forgot your password?",
      "title_password_reset": "Reset your password",
      "title_expired_reset": "Whoops, that's an expired link..",
      "title_expired_signup": "This invite link is no longer active",
      "title_signup": "Complete your registration",
      "backToLogin": "Back to login",
      "cookiePolicy": "Cookie Policy",
      "privacyPolicy": "Privacy Policy",
      "googleLogin": "Sign in with Google",
      "emailAddress": "Email address",
      "emailAddressRequired": "Email address is required",
      "emailAddressInvalid": "Enter a valid email address",
      "notification_error_session_expired": "Your session has expired, please login again.",
      "notification_error_no_access": "Your account does not have access.",
      "notification_success_logout": "You signed out of your account.",
      "password": "Password",
      "password_confirm": "Password confirmation",
      "passwordForgot": "Forgot your password?",
      "passwordRequired": "Password is required",
      "passwordLengthRequired": "Password must contain at least 8 characters",
      "passwordConfirmRequired": "Password confirmation is required",
      "passwordConfirmMatchRequired": "Password confirmation does not match",
      "success_password_forgot": "If you have an active account, a password reset email has been sent to {email}. Please check your email inbox, the password reset link expires in 1 hour.",
      "success_password_reset": "Password reset successful, logging you in now...",
      "submit_login": "Sign in",
      "submit_password_forgot": "Request password reset",
      "submit_password_reset": "Reset password",
      "submit_expired_reset": "Request a new password reset",
      "submit_expired_signup": "Return to login",
      "submit_signup": "Create account",
      "termsandconditionsPolicy": "Terms and Conditions"
    }
  }
}
